<div class="card">
  <app-header titulo="Widgets" descricao="Cadastro dos widgets disponíveis para o dashboard"></app-header>

  <p-message *ngIf="acessoNegado; else conteudo" severity="warn" text="Acesso restrito a administradores" styleClass="w-full justify-content-start" />

  <ng-template #conteudo>
    <div class="flex flex-wrap gap-2 align-items-center">
      <a [routerLink]="['novo']"><button pButton icon="pi pi-plus" label="Novo widget"></button></a>

      <span class="p-input-icon-left ml-auto filtro-texto">
        <i class="pi pi-search"></i>
        <input pInputText type="text" [(ngModel)]="filtroTexto" placeholder="Nome ou identificador" class="w-full" />
      </span>

      <p-dropdown [options]="modulos" [(ngModel)]="filtroModulo" placeholder="Todos os módulos" [showClear]="true" [filter]="true" filterBy="label" styleClass="filtro-select" />

      <p-dropdown [options]="status" [(ngModel)]="filtroStatus" placeholder="Todos os status" [showClear]="true" styleClass="filtro-select" />
    </div>

    <div class="mt-3">
      <p-table [value]="widgetsFiltrados" dataKey="id" [loading]="carregando" [paginator]="widgetsFiltrados.length > 20" [rows]="20"
        sortField="nome" [sortOrder]="1" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 4rem">Ícone</th>
            <th pSortableColumn="nome">Nome <p-sortIcon field="nome" /></th>
            <th pSortableColumn="identificador">Identificador <p-sortIcon field="identificador" /></th>
            <th pSortableColumn="moduloDescricao">Módulo <p-sortIcon field="moduloDescricao" /></th>
            <th style="width: 7rem">Tamanho</th>
            <th pSortableColumn="ativo" style="width: 7rem">Status <p-sortIcon field="ativo" /></th>
            <th style="width: 7rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-widget>
          <tr>
            <td class="text-center"><i *ngIf="widget.icone" [class]="widget.icone" class="icone"></i></td>
            <td>{{ widget.nome }}</td>
            <td><code>{{ widget.identificador }}</code></td>
            <td>{{ widget.moduloDescricao || widget.moduloNome }}</td>
            <td>{{ widget.largura }} × {{ widget.altura }}</td>
            <td>
              <p-tag [value]="widget.ativo ? 'Ativo' : 'Inativo'" [severity]="widget.ativo ? 'success' : 'warning'" />
            </td>
            <td class="text-right white-space-nowrap">
              <a [routerLink]="['editar', widget.id]">
                <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="info" pTooltip="Editar" ariaLabel="Editar" />
              </a>
              <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger" pTooltip="Excluir" ariaLabel="Excluir" (onClick)="excluir(widget)" />
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" class="text-center">Nenhum widget encontrado.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </ng-template>

  <p-confirmDialog [style]="{ width: '450px' }" />
</div>
